import React, { useContext, useEffect, useState } from 'react';
import path from 'path-browserify';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

import { PageContext } from '../PageContext';
import { LinkComponentFragment, Maybe } from '../../../graphql.schema';
import { addTrailingSlash } from '../../lib/helpers';

export function isExternalURL(url: string) {
  try {
    return new URL(url).host !== location.host;
  } catch (e) {
    return false;
  }
}

export type StrapiLinkProps = Omit<LinkComponentFragment, 'id' | 'title' | 'openInNewWindow'> & {
  id?: string | number;
  className?: string;
  openInNewWindow?: Maybe<boolean>;
};

const StrapiLinkUnstyled: React.FC<StrapiLinkProps> = (props) => {
  const [url, setUrl] = useState(props.page?.slug ?? props.url ?? '');
  const context = useContext(PageContext);

  useEffect(() => {
    setUrl(props.page?.slug ?? props.url ?? '')
  }, [props.page?.slug, props.url]);

  const extraProps = {
    target: props.openInNewWindow ? '__blank' : undefined,
    rel: props.nofollow ? 'nofollow' : undefined,
  };

  // If target=_blank, add noreferrer for security
  if (props.openInNewWindow && extraProps.rel) {
    extraProps.rel = `${extraProps.rel} noreferrer`;
  }

  // Check if incoming string is an url or an endpoint
  const isUrl = (redirectURI: string): boolean => {
    try {
      new URL(redirectURI);
      return true;
    } catch (err) {
      return false;
    }
  }
  const sanitizeUrl = (url: string): string => url.replace(new RegExp(`^${context.pathPrefixes.root}`), '');
 
  const rootpath = path.join(!url.includes('#') ? context.pathPrefixes.root : '', sanitizeUrl(url))

 // const handleFormScroll = (url: string): string => url.includes('#') ? url : `${global.window?.origin ?? ''}${rootpath}`
  const handleFormScroll = (url: string): string => {
    if (url.includes('#')) return url;
    return rootpath.startsWith('/') ? addTrailingSlash(rootpath) : `/${addTrailingSlash(rootpath)}`;
  };
  return isExternalURL(url) || props.openInNewWindow ? (
    <a href={url} className={props.className} {...extraProps} data-testid={props.id}>
      {props.children}
    </a>
  ) : (
    <AnchorLink className={props.className} to={isUrl(url) ? addTrailingSlash(url) : handleFormScroll(url)} {...extraProps}>
      {props.children}
    </AnchorLink>
  );
};

export default StrapiLinkUnstyled;
